import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.process.DOC}
  query ScenarioProcesses(
    $zoneId: ID!
    $tenantId: ID!
    $appId: ID!
    $scenarioId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            processes {
              ...FragmentProcessEssentials
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.ScenarioProcessesQuery,
    ents.core.relay.processes.Process.Essentials[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'processes',
            graphql.transformers.OUT.list(fragments.process.TRANSFORMER, {
              onNullish: 'remove',
            }),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.ScenarioProcessesQuery,
  ents.core.relay.processes.Process.Essentials[],
  graphql.schema.ScenarioProcessesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
